export const newGameButtonState =  {
    state:() => ({
    }),
    mutations: {
    },
    actions: {
    }
};
  